// src/components/notification-center/notification-center.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation DeleteNotificationById($contextInput: ContextInput, $notificationId: String!) {\n    deleteNotificationById(context: $contextInput, notificationId: $notificationId) {\n      operationStatus\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  mutation UpdateInboxState($contextInput: ContextInput, $ids: [String!]!, $state: NotificationState!) {\n    updateInboxState(context: $contextInput, notificationIds: $ids, state: $state) {\n      notificationId\n      operationStatus\n      notificationState\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  query NotificationCenterQuery($context: ContextInput!) {\n    notification(context: $context) {\n      notificationCenter {\n        unseen\n        redirectPath\n        revealActions {\n          __typename\n          ... on NotificationAnalytics {\n            description\n            referrerId\n          }\n        }\n        title {\n          completeText\n          items {\n            __typename\n            text\n            styles\n            ... on NotificationPhraseLinkNode {\n              id\n              type\n              uri {\n                __typename\n                value\n              }\n              target\n              actions {\n                __typename\n                ... on NotificationAnalytics {\n                  description\n                  referrerId\n                }\n              }\n            }\n          }\n        }\n        icon {\n          id\n          description\n        }\n        emptyState {\n          title {\n            completeText\n            items {\n              __typename\n              text\n              styles\n              ... on NotificationPhraseLinkNode {\n                id\n                type\n                uri {\n                  __typename\n                  value\n                }\n                target\n                actions {\n                  __typename\n                  ... on NotificationAnalytics {\n                    description\n                    referrerId\n                  }\n                }\n              }\n            }\n          }\n          body {\n            completeText\n            items {\n              __typename\n              text\n              styles\n              ... on NotificationPhraseLinkNode {\n                id\n                type\n                uri {\n                  __typename\n                  value\n                }\n                target\n                actions {\n                  __typename\n                  ... on NotificationAnalytics {\n                    description\n                    referrerId\n                  }\n                }\n              }\n            }\n          }\n          icon {\n            id\n            description\n          }\n        }\n        deleteActionForm {\n          title\n          sections {\n            title\n            fields {\n              label\n              __typename\n            }\n          }\n          feedbackMessages {\n            name\n            title\n            text\n            displayType\n            level\n          }\n        }\n        notifications {\n          type\n          subType\n          containerLink {\n            id\n            uri {\n              __typename\n              value\n            }\n            target\n            actions {\n              __typename\n              ... on NotificationAnalytics {\n                description\n                referrerId\n              }\n            }\n          }\n          logo {\n            url\n          }\n          backgroundImage {\n            url\n          }\n          title {\n            completeText\n            items {\n              __typename\n              text\n              styles\n              ... on NotificationPhraseLinkNode {\n                id\n                type\n                uri {\n                  __typename\n                  value\n                }\n                target\n                actions {\n                  __typename\n                  ... on NotificationAnalytics {\n                    description\n                    referrerId\n                  }\n                }\n              }\n            }\n          }\n          body {\n            completeText\n            items {\n              __typename\n              text\n              styles\n              ... on NotificationPhraseLinkNode {\n                id\n                type\n                uri {\n                  __typename\n                  value\n                }\n                target\n                actions {\n                  __typename\n                  ... on NotificationAnalytics {\n                    description\n                    referrerId\n                  }\n                }\n              }\n            }\n          }\n          icon {\n            id\n            description\n          }\n          revealActions {\n            __typename\n            ... on NotificationAnalytics {\n              description\n              referrerId\n            }\n            ... on NotificationMarketing {\n              marketingCode\n              marketingCodeDetail\n            }\n          }\n          links {\n            text\n            uri {\n              __typename\n              value\n            }\n            actions {\n              __typename\n              ... on NotificationAnalytics {\n                description\n                referrerId\n              }\n            }\n          }\n          state\n          timeStamp\n          notificationId\n          userActions {\n            __typename\n            type\n            text\n            icon {\n              id\n              description\n              title\n            }\n            actions {\n              __typename\n              ... on NotificationAnalytics {\n                description\n                referrerId\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  query GlobalHeaderQuery(\n    $context: ContextInput!\n    $viewSize: HeaderViewSize\n    $lineOfBusiness: GlobalNavigationLineOfBusiness\n    $layout: HeaderLayout\n  ) {\n    globalHeader(context: $context, viewSize: $viewSize, lineOfBusiness: $lineOfBusiness, layout: $layout) {\n      redDotState @client\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React15 from "react";
import { useApolloClient as useApolloClient2, useMutation as useMutation3, useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize6 } from "uitk-react-button";
import { UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
// src/provider/nc-list-provider.tsx
import React, { createContext, useReducer } from "react";
// src/provider/nc-list-reducer.ts
var nc_list_reducer_default = function(state, action) {
    var doesPayloadContain = function doesPayloadContain(notification) {
        var _action_payload;
        var foundNotification = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.find(function(payloadNotification) {
            return payloadNotification.notificationId === notification.notificationId;
        });
        return foundNotification !== null && foundNotification !== void 0;
    };
    var setNotificationState = function setNotificationState(notificationState) {
        return state.notificationsList.map(function(notification) {
            if (doesPayloadContain(notification)) {
                return _objectSpreadProps(_objectSpread({}, notification), {
                    state: notificationState
                });
            }
            return notification;
        });
    };
    var emptyNotificationsReducerObject = {
        notificationsList: [],
        unseenCount: 0
    };
    switch(action.action){
        case 0 /* MARK_AS_UNREAD */ :
            return _objectSpreadProps(_objectSpread({}, state), {
                notificationsList: setNotificationState("SEEN" /* SEEN */ ),
                unseenCount: 0
            });
        case 1 /* MARK_AS_READ */ :
            return _objectSpreadProps(_objectSpread({}, state), {
                notificationsList: setNotificationState("READ" /* READ */ ),
                unseenCount: 0
            });
        case 2 /* DELETE */ :
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    notificationsList: state.notificationsList.filter(function(notification) {
                        return !doesPayloadContain(notification);
                    }),
                    unseenCount: 0
                });
            }
        default:
            return emptyNotificationsReducerObject;
    }
};
// src/provider/nc-list-provider.tsx
var DEFAULT = {
    lineOfBusiness: "UNKNOWN",
    notificationCenterObject: {
        notificationsList: [],
        unseenCount: 0
    },
    viewSize: null,
    dispatch: function() {
        return [];
    }
};
var NotificationsContext = createContext(DEFAULT);
var NcListProvider = function(props) {
    var notificationCenterObject = props.notificationCenterObject, lineOfBusiness = props.lineOfBusiness, viewSize = props.viewSize, children = props.children;
    var _useReducer = _slicedToArray(useReducer(nc_list_reducer_default, {
        notificationsList: notificationCenterObject.notificationsList,
        unseenCount: notificationCenterObject.unseenCount
    }), 2), localNotifications = _useReducer[0], dispatch = _useReducer[1];
    return /* @__PURE__ */ React.createElement(NotificationsContext.Provider, {
        value: {
            notificationCenterObject: localNotifications,
            dispatch: dispatch,
            lineOfBusiness: lineOfBusiness,
            viewSize: viewSize
        }
    }, children || null);
};
var useNotificationsDispatcher = function() {
    return React.useContext(NotificationsContext);
};
// src/components/notification-center/helpers/nc-web-impression-actions-executor.ts
var fireTracking = function(actions, analyticsTracker, appendClick) {
    if (actions) {
        var actionsAnalytics = [];
        actions.forEach(function(action) {
            if (action.__typename === "NotificationAnalytics") {
                actionsAnalytics.push(action);
            }
        });
        if (analyticsTracker) {
            actionsAnalytics.forEach(function(action) {
                var referrerId = action.referrerId;
                if (appendClick) {
                    referrerId = "".concat(action.referrerId, ".Click");
                }
                analyticsTracker(referrerId, action.description || "");
            });
        }
    }
};
var ncWebImpressionActionsExecutor = function(analyticsTracker, inboxNotifications) {
    if (inboxNotifications) {
        var screenLoadTracking = "Web.Notification.NC.Opened.".concat(inboxNotifications.length);
        analyticsTracker(screenLoadTracking, "Notification Screen load");
        if (inboxNotifications.length > 0) {
            inboxNotifications.forEach(function(inbox) {
                fireTracking(inbox.revealActions, analyticsTracker, false);
            });
        }
    }
};
// src/components/notification-center/helpers/redirect-gss-url.ts
var redirectGSSUrl = function(redirectPath) {
    var queryParams = "";
    if (typeof window !== "undefined" && window.location !== null) {
        var locationPathname = window.location.pathname ? window.location.pathname : "";
        var locationSearch = window.location.search ? window.location.search : "";
        var locationHash = window.location.hash ? window.location.hash : "";
        var returnUrl = locationPathname.concat(locationSearch, locationHash);
        queryParams = "&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
    }
    return redirectPath + queryParams;
};
// src/components/notification-center/notification-center-dialog.tsx
import React11 from "react";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/notification-center/nc-content-wrapper.tsx
import React9 from "react";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/notification-center/nc-empty-state.tsx
import React2 from "react";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var NcEmptyState = function(props) {
    var _emptyState_title, _emptyState_body;
    var ncIcon = props.ncIcon, emptyState = props.emptyState;
    return /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        alignContent: "center",
        justifyContent: "center",
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            inlinestart: "four",
            inlineend: "four"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, {
        alignSelf: "center"
    }, /* @__PURE__ */ React2.createElement("section", null, /* @__PURE__ */ React2.createElement(UitkText, {
        align: "center"
    }, /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: ncIcon,
        size: UitkIconSize.LARGE
    })), /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "four",
            blockend: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkHeading, {
        align: "center",
        tag: "h1",
        size: 5
    }, (_emptyState_title = emptyState.title) === null || _emptyState_title === void 0 ? void 0 : _emptyState_title.items[0].text)), /* @__PURE__ */ React2.createElement(UitkText, {
        align: "center",
        size: 300
    }, (_emptyState_body = emptyState.body) === null || _emptyState_body === void 0 ? void 0 : _emptyState_body[0].items[0].text)))))));
};
// src/components/notification-center/nc-list.tsx
import React8 from "react";
import { useMutation as useMutation2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkDotNotificationBadge } from "uitk-react-badge";
import { UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText2 } from "uitk-react-text";
// src/components/notification-center/nc-deeplink-handler.tsx
import React3 from "react";
var NcDeeplinkHandler = function(props) {
    var _notification_links__uri, _notification_links, _notification_links__uri1, _notification_links1;
    var notification = props.notification, onClick = props.onClick, children = props.children;
    var deeplink = ((_notification_links__uri = (_notification_links = notification.links) === null || _notification_links === void 0 ? void 0 : _notification_links[0].uri) === null || _notification_links__uri === void 0 ? void 0 : _notification_links__uri.value) ? (_notification_links__uri1 = (_notification_links1 = notification.links) === null || _notification_links1 === void 0 ? void 0 : _notification_links1[0].uri) === null || _notification_links__uri1 === void 0 ? void 0 : _notification_links__uri1.value : "#";
    return /* @__PURE__ */ React3.createElement("a", {
        href: deeplink,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onClick
    }, children);
};
// src/components/notification-center/nc-nested-dialog.tsx
import React7 from "react";
import { useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkHeading as UitkHeading2, UitkParagraph } from "uitk-react-text";
// src/components/notification-center/nc-actions-bottom-sheet.tsx
import React5 from "react";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkMenuList } from "uitk-react-menu";
import { UitkScrim, UitkScrimColorType, UitkScrimType } from "uitk-react-scrim";
import { UitkSheet } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/components/notification-center/notification-center-actions-menu-button.tsx
import React4 from "react";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
var NotificationCenterActionsMenuButton = function(props) {
    var name = props.name, buttonSize = props.buttonSize, iconSize = props.iconSize, onClick = props.onClick;
    return /* @__PURE__ */ React4.createElement(UitkTertiaryButton, {
        size: buttonSize,
        onClick: onClick
    }, /* @__PURE__ */ React4.createElement(UitkIcon2, {
        name: name,
        size: iconSize
    }));
};
// src/components/notification-center/nc-actions-bottom-sheet.tsx
var NcActionsBottomSheet = function(props) {
    var sheetState = props.sheetState, onSheetOpenTriggerClick = props.onSheetOpenTriggerClick, actionItems = props.actionItems;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(NotificationCenterActionsMenuButton, {
        name: "more_vert",
        buttonSize: UitkButtonSize2.MEDIUM,
        iconSize: UitkIconSize3.MEDIUM,
        onClick: onSheetOpenTriggerClick
    }), sheetState && /* @__PURE__ */ React5.createElement("div", {
        tabIndex: 0,
        role: "button",
        onKeyDown: onSheetOpenTriggerClick,
        onClick: onSheetOpenTriggerClick
    }, /* @__PURE__ */ React5.createElement(UitkScrim, {
        type: UitkScrimType.OVERLAY,
        color: UitkScrimColorType.PRIMARY
    })), /* @__PURE__ */ React5.createElement(UitkSheet, {
        isVisible: sheetState,
        triggerRef: null
    }, /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkMenuList, {
        items: actionItems
    })))));
};
// src/components/notification-center/nc-actions-menu.tsx
import React6 from "react";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuList as UitkMenuList2, UitkMenuTrigger } from "uitk-react-menu";
var NcActionsMenu = function(props) {
    var menuState = props.menuState, onMenuOpenTriggerClick = props.onMenuOpenTriggerClick, actionItems = props.actionItems, actionState = props.actionState, setActionState = props.setActionState;
    var actionRef = React6.useRef(null);
    React6.useEffect(function() {
        var handleClickOutside = function(event) {
            var _actionRef_current;
            if (!((_actionRef_current = actionRef.current) === null || _actionRef_current === void 0 ? void 0 : _actionRef_current.contains(event.target)) && menuState) {
                setActionState(new Array(actionState.length).fill(false));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        actionRef,
        actionState,
        menuState,
        setActionState
    ]);
    return /* @__PURE__ */ React6.createElement("div", {
        ref: actionRef
    }, /* @__PURE__ */ React6.createElement(UitkMenu, {
        isOpen: menuState
    }, /* @__PURE__ */ React6.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React6.createElement(NotificationCenterActionsMenuButton, {
        name: "more_vert",
        buttonSize: UitkButtonSize3.MEDIUM,
        iconSize: UitkIconSize4.MEDIUM,
        onClick: onMenuOpenTriggerClick
    })), /* @__PURE__ */ React6.createElement(UitkMenuContainer, {
        position: PositionType.RIGHT
    }, /* @__PURE__ */ React6.createElement(UitkMenuList2, {
        items: actionItems
    }))));
};
// src/components/notification-center/queries_and_mutations/delete-notification-by-id-mutation.ts
import { gql } from "@apollo/client";
var __DeleteNotificationByIdMutation = gql(_templateObject());
// src/components/notification-center/queries_and_mutations/nc-delete-notification-by-id-mutation.tsx
function ncDeleteNotificationByIdMutation(deleteNotificationById, contextInput, id) {
    return deleteNotificationById({
        variables: {
            contextInput: contextInput,
            notificationId: id
        }
    });
}
// src/components/notification-center/queries_and_mutations/nc-update-inbox-state-mutation.tsx
function ncUpdateInboxStateMutation(updateInbox, contextInput, notificationIdList, notificationState) {
    return updateInbox({
        variables: {
            contextInput: contextInput,
            ids: notificationIdList,
            state: notificationState
        }
    });
}
// src/components/notification-center/queries_and_mutations/update-inbox-state-mutation.ts
import { gql as gql2 } from "@apollo/client";
var __UpdateInboxStateMutation = gql2(_templateObject1());
// src/components/notification-center/nc-nested-dialog.tsx
var NcNestedDialog = function(props) {
    var getMenuItemForDelete = function getMenuItemForDelete(userAction) {
        var _userAction_icon;
        return {
            attributes: {
                role: "menuitem",
                tabindex: 0
            },
            className: "uitk-list-item",
            icon: {
                name: (_userAction_icon = userAction.icon) === null || _userAction_icon === void 0 ? void 0 : _userAction_icon.id
            },
            label: userAction.text,
            onClick: onDeleteActionClick,
            typeAnchor: true
        };
    };
    var getMenuItemForReadUnread = function getMenuItemForReadUnread(userAction, clickAction) {
        var _userAction_icon;
        return {
            attributes: {
                role: "menuitem",
                tabindex: 0
            },
            className: "uitk-list-item",
            icon: {
                name: (_userAction_icon = userAction.icon) === null || _userAction_icon === void 0 ? void 0 : _userAction_icon.id
            },
            onClick: clickAction,
            label: userAction.text,
            typeAnchor: true
        };
    };
    var getMenuItemForReadMsg = function getMenuItemForReadMsg(userActions) {
        return [
            getMenuItemForDelete(userActions[0]),
            getMenuItemForReadUnread(userActions[2], function() {
                return onMarkAsUnreadActionClick(userActions[2]);
            })
        ];
    };
    var getMenuItemForUnreadMsg = function getMenuItemForUnreadMsg(userActions) {
        return [
            getMenuItemForDelete(userActions[0]),
            getMenuItemForReadUnread(userActions[1], function() {
                return onMarkAsReadActionClick(userActions[1]);
            })
        ];
    };
    var getActionItems = function getActionItems() {
        var state = notification.state, userActions = notification.userActions;
        if (!userActions || userActions.length !== 3) {
            return [];
        }
        if (state === "READ" /* READ */ ) {
            return getMenuItemForReadMsg(userActions);
        }
        return getMenuItemForUnreadMsg(userActions);
    };
    var _props_deleteActionForm = props.deleteActionForm, sections = _props_deleteActionForm.sections, title = _props_deleteActionForm.title, notification = props.notification, actionState = props.actionState, setActionState = props.setActionState, index = props.index, setMenuClickHandlerState = props.setMenuClickHandlerState;
    var originalActionState = new Array(actionState.length).fill(false);
    var dispatch = useNotificationsDispatcher().dispatch;
    var context = useBexApi().context;
    var _useDialog = _slicedToArray(useDialog("notification-center-delete-action-".concat(notification.notificationId), "notificationCenterDeleteDialog"), 3), isNestedDialogOpen = _useDialog[0], nestedDialogActions = _useDialog[1], NestedDialogComponent = _useDialog[2];
    var _useMutation = _slicedToArray(useMutation(__DeleteNotificationByIdMutation), 1), deleteNotificationById = _useMutation[0];
    var _useMutation1 = _slicedToArray(useMutation(__UpdateInboxStateMutation), 1), updateInboxState = _useMutation1[0];
    var track = useClickTracker();
    var onActionListTriggerClick = function() {
        if (!actionState[index]) {
            track("Web.Notification.InApp.ActionList.Click", "user action list click");
        }
        var newActions = _toConsumableArray(originalActionState);
        newActions[index] = !actionState[index];
        setActionState(newActions);
    };
    React7.useEffect(function() {
        var disableMenuBodyClickHandler = function(disable) {
            if (setMenuClickHandlerState) {
                setMenuClickHandlerState(disable);
            }
        };
        if (isNestedDialogOpen) {
            disableMenuBodyClickHandler(true);
        } else {
            disableMenuBodyClickHandler(false);
        }
    }, [
        isNestedDialogOpen,
        setMenuClickHandlerState
    ]);
    var onDeleteActionClick = function() {
        setActionState(originalActionState);
        nestedDialogActions.openDialog();
    };
    var onMarkAsReadActionClick = function(userAction) {
        fireTracking(userAction.actions, track, false);
        setActionState(originalActionState);
        dispatch({
            action: 1 /* MARK_AS_READ */ ,
            payload: [
                notification
            ]
        });
        ncUpdateInboxStateMutation(updateInboxState, context, [
            notification.notificationId || ""
        ], "READ" /* READ */ );
    };
    var onMarkAsUnreadActionClick = function(userAction) {
        fireTracking(userAction.actions, track, false);
        setActionState(originalActionState);
        dispatch({
            action: 0 /* MARK_AS_UNREAD */ ,
            payload: [
                notification
            ]
        });
        ncUpdateInboxStateMutation(updateInboxState, context, [
            notification.notificationId || ""
        ], "SEEN" /* SEEN */ );
    };
    var handleConfirmClick = function(chosenNotification) {
        var _chosenNotification_userActions;
        fireTracking(chosenNotification === null || chosenNotification === void 0 ? void 0 : (_chosenNotification_userActions = chosenNotification.userActions) === null || _chosenNotification_userActions === void 0 ? void 0 : _chosenNotification_userActions[0].actions, track, false);
        dispatch({
            action: 2 /* DELETE */ ,
            payload: [
                chosenNotification
            ]
        });
        setActionState(originalActionState);
        nestedDialogActions.closeDialog();
        ncDeleteNotificationByIdMutation(deleteNotificationById, context, notification.notificationId || "");
    };
    var handleCancelClick = function() {
        setActionState(originalActionState);
        nestedDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(Viewport, null, /* @__PURE__ */ React7.createElement(ViewMedium, null, /* @__PURE__ */ React7.createElement(NcActionsMenu, {
        menuState: actionState[index],
        onMenuOpenTriggerClick: function() {
            return onActionListTriggerClick();
        },
        actionItems: getActionItems(),
        actionState: actionState,
        setActionState: setActionState
    })), /* @__PURE__ */ React7.createElement(ViewSmall, null, /* @__PURE__ */ React7.createElement(NcActionsBottomSheet, {
        sheetState: actionState[index],
        onSheetOpenTriggerClick: function() {
            return onActionListTriggerClick();
        },
        actionItems: getActionItems()
    }))), isNestedDialogOpen && /* @__PURE__ */ React7.createElement(NestedDialogComponent, null, /* @__PURE__ */ React7.createElement(UitkDialog, {
        dialogShow: true,
        returnFocusOnClose: true,
        autoFocus: true
    }, /* @__PURE__ */ React7.createElement(UitkDialogContent, null, /* @__PURE__ */ React7.createElement(UitkHeading2, {
        tag: "h1",
        size: 5,
        key: "dialogHeading"
    }, title), /* @__PURE__ */ React7.createElement(UitkParagraph, {
        key: "dialogParagraph",
        size: 2
    }, sections[0].title), /* @__PURE__ */ React7.createElement(UitkDialogFooter, {
        key: "UitkDialogFooter",
        stacked: true,
        buttonOne: {
            onClick: function() {
                handleConfirmClick(notification);
            },
            text: sections[0].fields[0].label,
            type: "primary"
        },
        buttonTwo: {
            onClick: handleCancelClick,
            text: sections[0].fields[1].label,
            type: "tertiary"
        }
    })))));
};
// src/components/notification-center/nc-list.tsx
var NcList = function(props) {
    var _notificationCenterObject_notificationsList;
    var deleteActionForm = props.deleteActionForm, setMenuClickHandlerState = props.setMenuClickHandlerState;
    var notificationCenterObject = useNotificationsDispatcher().notificationCenterObject;
    var context = useBexApi2().context;
    var track = useClickTracker2();
    var dispatch = useNotificationsDispatcher().dispatch;
    var _useMutation2 = _slicedToArray(useMutation2(__UpdateInboxStateMutation), 1), updateInbox = _useMutation2[0];
    var onNotificationCellClick = function(notification) {
        fireTracking(notification.revealActions, track, true);
        if (notification.state !== "READ" /* READ */ ) {
            dispatch({
                action: 1 /* MARK_AS_READ */ ,
                payload: [
                    notification
                ]
            });
            ncUpdateInboxStateMutation(updateInbox, context, [
                notification.notificationId
            ], "READ" /* READ */ );
        }
    };
    var originalActionState = new Array((_notificationCenterObject_notificationsList = notificationCenterObject.notificationsList) === null || _notificationCenterObject_notificationsList === void 0 ? void 0 : _notificationCenterObject_notificationsList.length).fill(false);
    var _React8_useState = _slicedToArray(React8.useState(originalActionState), 2), actionState = _React8_useState[0], setActionState = _React8_useState[1];
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, notificationCenterObject.notificationsList.map(function(notification, index) {
        var _notification_icon, _notification_links__uri, _notification_links, _notification_links__uri1, _notification_links1, _notification_title, _notification_title_items, _notification_title1, _notification_title_items1, _notification_title2, _notification_title_items2, _notification_body, _notification_body_, _notification_body__items, _notification_body1, _notification_body_1, _notification_body__items1;
        /* @__PURE__ */ return React8.createElement("div", {
            key: "notifications-cell-".concat(index),
            "data-stid": "notifications-cell"
        }, /* @__PURE__ */ React8.createElement(UitkSpacing3, {
            padding: {
                block: "three",
                inlinestart: "one",
                inlineend: "half"
            }
        }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
            alignSelf: "start",
            grow: 0
        }, /* @__PURE__ */ React8.createElement(NcDeeplinkHandler, {
            notification: notification,
            onClick: function() {
                return onNotificationCellClick(notification);
            }
        }, /* @__PURE__ */ React8.createElement(UitkCardContentSection2, {
            padded: [
                "blockstart",
                "blockend",
                "inlinestart"
            ]
        }, /* @__PURE__ */ React8.createElement(UitkSpacing3, {
            margin: {
                blockstart: "one"
            }
        }, /* @__PURE__ */ React8.createElement(UitkDotNotificationBadge, {
            visible: notification.state === "SEEN" /* SEEN */ 
        }))))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
            alignSelf: "start",
            grow: 0
        }, /* @__PURE__ */ React8.createElement(NcDeeplinkHandler, {
            notification: notification,
            onClick: function() {
                return onNotificationCellClick(notification);
            }
        }, /* @__PURE__ */ React8.createElement(UitkCardContentSection2, {
            padded: [
                "blockstart",
                "blockend",
                "inlinestart"
            ]
        }, notification.icon && /* @__PURE__ */ React8.createElement(UitkIcon3, {
            name: (_notification_icon = notification.icon) === null || _notification_icon === void 0 ? void 0 : _notification_icon.id,
            size: UitkIconSize5.MEDIUM
        })))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
            grow: 1
        }, /* @__PURE__ */ React8.createElement(UitkCardContentSection2, {
            padded: [
                "blockstart",
                "blockend",
                "inlinestart"
            ]
        }, /* @__PURE__ */ React8.createElement(UitkCardLink, null, /* @__PURE__ */ React8.createElement("a", {
            href: ((_notification_links__uri = (_notification_links = notification.links) === null || _notification_links === void 0 ? void 0 : _notification_links[0].uri) === null || _notification_links__uri === void 0 ? void 0 : _notification_links__uri.value) ? (_notification_links__uri1 = (_notification_links1 = notification.links) === null || _notification_links1 === void 0 ? void 0 : _notification_links1[0].uri) === null || _notification_links__uri1 === void 0 ? void 0 : _notification_links__uri1.value : "#",
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: function() {
                return onNotificationCellClick(notification);
            }
        }, (_notification_title = notification.title) === null || _notification_title === void 0 ? void 0 : (_notification_title_items = _notification_title.items) === null || _notification_title_items === void 0 ? void 0 : _notification_title_items[0].text)), ((_notification_title1 = notification.title) === null || _notification_title1 === void 0 ? void 0 : (_notification_title_items1 = _notification_title1.items) === null || _notification_title_items1 === void 0 ? void 0 : _notification_title_items1[0].text) && /* @__PURE__ */ React8.createElement(UitkHeading3, {
            tag: "h2",
            size: 5
        }, (_notification_title2 = notification.title) === null || _notification_title2 === void 0 ? void 0 : (_notification_title_items2 = _notification_title2.items) === null || _notification_title_items2 === void 0 ? void 0 : _notification_title_items2[0].text), ((_notification_body = notification.body) === null || _notification_body === void 0 ? void 0 : (_notification_body_ = _notification_body[0]) === null || _notification_body_ === void 0 ? void 0 : (_notification_body__items = _notification_body_.items) === null || _notification_body__items === void 0 ? void 0 : _notification_body__items[0].text) && /* @__PURE__ */ React8.createElement(UitkSpacing3, {
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React8.createElement(UitkText2, {
            overflow: "truncate-3-lines",
            size: 300,
            theme: "default",
            weight: notification.state === "SEEN" /* SEEN */  ? "bold" : "regular"
        }, (_notification_body1 = notification.body) === null || _notification_body1 === void 0 ? void 0 : (_notification_body_1 = _notification_body1[0]) === null || _notification_body_1 === void 0 ? void 0 : (_notification_body__items1 = _notification_body_1.items) === null || _notification_body__items1 === void 0 ? void 0 : _notification_body__items1[0].text)), notification.timeStamp && /* @__PURE__ */ React8.createElement(UitkSpacing3, {
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React8.createElement(UitkText2, {
            size: 100,
            theme: "default",
            spacing: "two"
        }, notification.timeStamp)))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React8.createElement(UitkCardContentSection2, {
            padded: [
                "blockstart",
                "blockend",
                "inlineend"
            ]
        }, /* @__PURE__ */ React8.createElement(NcNestedDialog, {
            deleteActionForm: deleteActionForm,
            notification: notification,
            actionState: actionState,
            setActionState: setActionState,
            index: index,
            setMenuClickHandlerState: setMenuClickHandlerState
        }))))));
    }));
};
// src/components/notification-center/nc-content-wrapper.tsx
var NCContentWrapper = function(props) {
    var ncIcon = props.ncIcon, emptyState = props.emptyState, deleteActionForm = props.deleteActionForm, setMenuClickHandlerState = props.setMenuClickHandlerState;
    var notificationCenterObject = useNotificationsDispatcher().notificationCenterObject;
    if (!notificationCenterObject.notificationsList || notificationCenterObject.notificationsList.length === 0) {
        return /* @__PURE__ */ React9.createElement(Viewport2, null, /* @__PURE__ */ React9.createElement(ViewMedium2, null, /* @__PURE__ */ React9.createElement("div", {
            style: {
                height: 450
            }
        }, /* @__PURE__ */ React9.createElement(NcEmptyState, {
            ncIcon: ncIcon,
            emptyState: emptyState
        }))), /* @__PURE__ */ React9.createElement(ViewSmall2, null, /* @__PURE__ */ React9.createElement("div", {
            style: {
                height: 500
            }
        }, /* @__PURE__ */ React9.createElement(NcEmptyState, {
            ncIcon: ncIcon,
            emptyState: emptyState
        }))));
    }
    return /* @__PURE__ */ React9.createElement(NcList, {
        deleteActionForm: deleteActionForm,
        setMenuClickHandlerState: setMenuClickHandlerState
    });
};
// src/components/notification-center/nc-dialog-wrapper.tsx
import React10 from "react";
import { useApolloClient } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkFloatingDotNotificationBadge } from "uitk-react-badge";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSheet as UitkSheet2, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/notification-center/notification-center-request-query.ts
import { gql as gql3 } from "@apollo/client";
var NotificationCenterRequestQuery = gql3(_templateObject2());
var __HeaderQuery = gql3(_templateObject3());
// src/components/notification-center/nc-dialog-wrapper.tsx
var NcDialogWrapper = function(props) {
    var ncTitle = props.ncTitle, ncRevealActions = props.ncRevealActions, children = props.children, isDialogOpen = props.isDialogOpen, dialogActions = props.dialogActions, DialogComponent = props.DialogComponent, onClick = props.onClick;
    var _useNotificationsDispatcher = useNotificationsDispatcher(), notificationCenterObject = _useNotificationsDispatcher.notificationCenterObject, lineOfBusiness = _useNotificationsDispatcher.lineOfBusiness, viewSize = _useNotificationsDispatcher.viewSize, dispatch = _useNotificationsDispatcher.dispatch;
    var client = useApolloClient();
    var context = useBexApi3().context;
    var triggerRef = React10.useRef(null);
    var ncDotImpressionAnalytics = ncRevealActions === null || ncRevealActions === void 0 ? void 0 : ncRevealActions[1];
    var ncDotImpressionReferrer = (ncDotImpressionAnalytics === null || ncDotImpressionAnalytics === void 0 ? void 0 : ncDotImpressionAnalytics.referrerId) || "";
    var ncDotImpressionLinkName = (ncDotImpressionAnalytics === null || ncDotImpressionAnalytics === void 0 ? void 0 : ncDotImpressionAnalytics.description) || "";
    var showRedDot = notificationCenterObject.unseenCount !== null && notificationCenterObject.unseenCount > 0;
    var triggerContent = /* @__PURE__ */ React10.createElement(UitkLayoutFlex3, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React10.createElement(UitkText3, {
        size: 300,
        theme: "default"
    }, ncTitle)), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, null, showRedDot && /* @__PURE__ */ React10.createElement(IntersectionTracker, {
        referrerId: ncDotImpressionReferrer,
        linkName: ncDotImpressionLinkName
    }, /* @__PURE__ */ React10.createElement(UitkFloatingDotNotificationBadge, {
        visible: true
    }))));
    var triggerOnClick = function() {
        client.writeQuery({
            query: __HeaderQuery,
            data: {
                globalHeader: {
                    redDotState: "NOT_VISIBLE" /* NOT_VISIBLE */ 
                }
            },
            variables: {
                context: context,
                viewSize: viewSize,
                lineOfBusiness: lineOfBusiness
            }
        });
        onClick(notificationCenterObject, dispatch);
        dialogActions.toggleDialog();
    };
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(UitkSpacing4, {
        padding: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React10.createElement(UitkLink, {
        onClick: triggerOnClick,
        domRef: triggerRef
    }, /* @__PURE__ */ React10.createElement("button", {
        type: "button"
    }, triggerContent))), isDialogOpen && /* @__PURE__ */ React10.createElement(DialogComponent, null, /* @__PURE__ */ React10.createElement(UitkSheet2, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React10.createElement(UitkToolbar, {
        navigationContent: {
            onClick: dialogActions.closeDialog,
            navType: "close"
        },
        toolbarTitle: ncTitle
    }), /* @__PURE__ */ React10.createElement(UitkSheetContent, {
        padded: false
    }, children))));
};
// src/components/notification-center/notification-center-dialog.tsx
var NotificationCenterDialog = function(props) {
    var ncTitle = props.ncTitle, ncIcon = props.ncIcon, ncRevealActions = props.ncRevealActions, emptyState = props.emptyState, deleteActionForm = props.deleteActionForm, onClick = props.onClick;
    var _useDialog2 = _slicedToArray(useDialog2("notification-center-settings"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    return /* @__PURE__ */ React11.createElement(NcDialogWrapper, {
        ncTitle: ncTitle,
        ncRevealActions: ncRevealActions,
        isDialogOpen: isDialogOpen,
        dialogActions: dialogActions,
        DialogComponent: DialogComponent,
        onClick: onClick
    }, /* @__PURE__ */ React11.createElement(NCContentWrapper, {
        ncIcon: ncIcon,
        emptyState: emptyState,
        deleteActionForm: deleteActionForm
    }));
};
NotificationCenterDialog.displayName = "NotificationCenterDialog";
// src/components/notification-center/notification-center-global-nav-button.tsx
import React12 from "react";
import { UitkFloatingDotNotificationBadge as UitkFloatingDotNotificationBadge2 } from "uitk-react-badge";
import { UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkLayoutPosition } from "uitk-react-layout-position";
var NotificationCenterGlobalNavButton = function(props) {
    var name = props.name, buttonSize = props.buttonSize, iconSize = props.iconSize, onClick = props.onClick;
    var notificationCenterObject = useNotificationsDispatcher().notificationCenterObject;
    return /* @__PURE__ */ React12.createElement(UitkTertiaryButton2, {
        className: "uitk-button-only-icon global-navigation-nav-button",
        size: buttonSize,
        onClick: onClick
    }, /* @__PURE__ */ React12.createElement(UitkLayoutPosition, {
        display: "inline-block",
        type: "relative"
    }, /* @__PURE__ */ React12.createElement(UitkIcon4, {
        name: name,
        size: iconSize
    }), /* @__PURE__ */ React12.createElement(UitkLayoutPosition, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, /* @__PURE__ */ React12.createElement(UitkFloatingDotNotificationBadge2, {
        visible: notificationCenterObject.unseenCount !== null && notificationCenterObject.unseenCount > 0
    }))));
};
// src/components/notification-center/notification-center-menu.tsx
import React14 from "react";
// src/components/notification-center/nc-menu-wrapper.tsx
import React13 from "react";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkFloatingDotNotificationBadge as UitkFloatingDotNotificationBadge3 } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize5, UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "uitk-react-menu";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
var NcMenuWrapper = function(props) {
    var ncTitle = props.ncTitle, ncIcon = props.ncIcon, ncRevealActions = props.ncRevealActions, children = props.children, isOpen = props.isOpen, setOpen = props.setOpen, onClick = props.onClick, menuClickHandlerState = props.menuClickHandlerState;
    var _useNotificationsDispatcher = useNotificationsDispatcher(), notificationCenterObject = _useNotificationsDispatcher.notificationCenterObject, dispatch = _useNotificationsDispatcher.dispatch;
    var onMenuTriggerClick = function() {
        setOpen(!isOpen);
    };
    var clickTracking = function() {
        if (!isOpen) {
            onClick(notificationCenterObject, dispatch);
        }
    };
    var ncDotImpressionAnalytics = ncRevealActions === null || ncRevealActions === void 0 ? void 0 : ncRevealActions[1];
    var ncDotImpressionReferrer = (ncDotImpressionAnalytics === null || ncDotImpressionAnalytics === void 0 ? void 0 : ncDotImpressionAnalytics.referrerId) || "";
    var ncDotImpressionLinkName = (ncDotImpressionAnalytics === null || ncDotImpressionAnalytics === void 0 ? void 0 : ncDotImpressionAnalytics.description) || "";
    var showRedDot = notificationCenterObject.unseenCount !== null && notificationCenterObject.unseenCount > 0;
    return /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem4, {
        minWidth: "zero",
        grow: 0
    }, /* @__PURE__ */ React13.createElement(UitkMenu2, {
        isOpen: isOpen,
        onTriggerClick: onMenuTriggerClick,
        disableBodyClickHandler: menuClickHandlerState
    }, /* @__PURE__ */ React13.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React13.createElement(UitkTertiaryButton3, {
        className: "uitk-button-only-icon global-navigation-nav-button",
        size: UitkButtonSize5.LARGE,
        onClick: clickTracking
    }, /* @__PURE__ */ React13.createElement(UitkLayoutPosition2, {
        display: "inline-block",
        type: "relative"
    }, /* @__PURE__ */ React13.createElement(UitkIcon5, {
        name: ncIcon,
        size: UitkIconSize7.LARGE
    }), /* @__PURE__ */ React13.createElement(UitkLayoutPosition2, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, showRedDot && /* @__PURE__ */ React13.createElement(IntersectionTracker2, {
        referrerId: ncDotImpressionReferrer,
        linkName: ncDotImpressionLinkName
    }, /* @__PURE__ */ React13.createElement(UitkFloatingDotNotificationBadge3, {
        visible: true
    })))))), /* @__PURE__ */ React13.createElement(UitkMenuContainer2, {
        position: PositionType2.RIGHT,
        autoPosition: true,
        width: 375,
        maxHeight: 576
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: 576
        },
        role: "menu"
    }, /* @__PURE__ */ React13.createElement(UitkCardContentSection3, {
        padded: true,
        border: "bottom"
    }, /* @__PURE__ */ React13.createElement(UitkHeading4, {
        size: 5,
        tag: "h1"
    }, ncTitle)), children))));
};
// src/components/notification-center/notification-center-menu.tsx
var NotificationCenterMenu = function(props) {
    var ncTitle = props.ncTitle, ncIcon = props.ncIcon, ncRevealActions = props.ncRevealActions, emptyState = props.emptyState, deleteActionForm = props.deleteActionForm, onClick = props.onClick;
    var _React14_useState = _slicedToArray(React14.useState(false), 2), isOpen = _React14_useState[0], setOpen = _React14_useState[1];
    var _React14_useState1 = _slicedToArray(React14.useState(false), 2), menuClickHandlerState = _React14_useState1[0], setMenuClickHandlerState = _React14_useState1[1];
    return /* @__PURE__ */ React14.createElement(NcMenuWrapper, {
        ncTitle: ncTitle,
        ncRevealActions: ncRevealActions,
        ncIcon: ncIcon,
        isOpen: isOpen,
        setOpen: setOpen,
        onClick: onClick,
        menuClickHandlerState: menuClickHandlerState
    }, /* @__PURE__ */ React14.createElement(NCContentWrapper, {
        ncIcon: ncIcon,
        emptyState: emptyState,
        deleteActionForm: deleteActionForm,
        setMenuClickHandlerState: setMenuClickHandlerState
    }));
};
NotificationCenterMenu.displayName = "NotificationCenterMenu";
// src/components/notification-center/notification-center.tsx
var __GetNotificationCenterQuery = NotificationCenterRequestQuery;
var NotificationCenter = function(props) {
    var getNotificationIds = function getNotificationIds(listOfNotifications) {
        return (listOfNotifications === null || listOfNotifications === void 0 ? void 0 : listOfNotifications.map(function(notification) {
            return notification.notificationId || "";
        }).filter(function(notificationId) {
            return notificationId !== "";
        })) || [];
    };
    var _data_notification, _notificationCenter_title_items_, _notificationCenter_title, _notificationCenter_icon;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var lineOfBusiness = inputs.lineOfBusiness, viewSize = inputs.viewSize;
    var context = useBexApi4().context;
    var client = useApolloClient2();
    var variables = {
        context: context
    };
    var onCompleted = function(data2) {
        var _data2_notification, _data2_notification_notificationCenter, _context_identity;
        var unseen2 = data2 === null || data2 === void 0 ? void 0 : (_data2_notification = data2.notification) === null || _data2_notification === void 0 ? void 0 : (_data2_notification_notificationCenter = _data2_notification.notificationCenter) === null || _data2_notification_notificationCenter === void 0 ? void 0 : _data2_notification_notificationCenter.unseen;
        if (unseen2 !== null && unseen2 > 0 && (context === null || context === void 0 ? void 0 : (_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "AUTHENTICATED") {
            client.writeQuery({
                query: __HeaderQuery,
                data: {
                    globalHeader: {
                        redDotState: "VISIBLE" /* VISIBLE */ 
                    }
                },
                variables: {
                    context: context,
                    viewSize: viewSize,
                    lineOfBusiness: lineOfBusiness
                }
            });
        }
    };
    var _useQuery = useQuery(__GetNotificationCenterQuery, {
        variables: variables,
        ssr: !skipSsr,
        onCompleted: onCompleted
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var _useMutation3 = _slicedToArray(useMutation3(__UpdateInboxStateMutation), 1), updateInboxState = _useMutation3[0];
    var track = useClickTracker3();
    if (loading || error || !data) {
        return null;
    }
    var notificationCenter = data === null || data === void 0 ? void 0 : (_data_notification = data.notification) === null || _data_notification === void 0 ? void 0 : _data_notification.notificationCenter;
    var ncTitle = (_notificationCenter_title_items_ = (_notificationCenter_title = notificationCenter.title) === null || _notificationCenter_title === void 0 ? void 0 : _notificationCenter_title.items[0]) === null || _notificationCenter_title_items_ === void 0 ? void 0 : _notificationCenter_title_items_.text;
    var ncRevealActions = notificationCenter === null || notificationCenter === void 0 ? void 0 : notificationCenter.revealActions;
    var ncIcon = (_notificationCenter_icon = notificationCenter.icon) === null || _notificationCenter_icon === void 0 ? void 0 : _notificationCenter_icon.id;
    var unseen = notificationCenter === null || notificationCenter === void 0 ? void 0 : notificationCenter.unseen;
    var emptyState = notificationCenter.emptyState, deleteActionForm = notificationCenter.deleteActionForm, notifications = notificationCenter.notifications, redirectPath = notificationCenter.redirectPath;
    if (!ncTitle || !ncIcon || !emptyState || !deleteActionForm || !notifications) return null;
    var entryPointClick = function() {
        var revealActions = notificationCenter.revealActions;
        if (revealActions && (revealActions === null || revealActions === void 0 ? void 0 : revealActions.length) > 0) {
            var arr = new Array(1).fill(revealActions[0]);
            fireTracking(arr, track, false);
        }
    };
    var ncScreenLoad = function(notificationsObject, dispatch) {
        var _notificationsObject_notificationsList;
        entryPointClick();
        var unseenNotifications = (_notificationsObject_notificationsList = notificationsObject.notificationsList) === null || _notificationsObject_notificationsList === void 0 ? void 0 : _notificationsObject_notificationsList.filter(function(notification) {
            return notification.state === "UNSEEN" /* UNSEEN */ ;
        });
        if (unseenNotifications && unseenNotifications.length > 0) {
            dispatch({
                action: 0 /* MARK_AS_UNREAD */ ,
                payload: unseenNotifications
            });
            var notificationIds = getNotificationIds(unseenNotifications);
            if (notificationIds && notificationIds.length > 0) {
                ncUpdateInboxStateMutation(updateInboxState, context, notificationIds, "SEEN" /* SEEN */ );
            }
        }
        ncWebImpressionActionsExecutor(track, notificationsObject.notificationsList);
    };
    if (redirectPath && redirectPath.length > 0) {
        return /* @__PURE__ */ React15.createElement(NcListProvider, {
            notificationCenterObject: {
                notificationsList: notifications,
                unseenCount: unseen || 0
            },
            lineOfBusiness: lineOfBusiness,
            viewSize: viewSize
        }, /* @__PURE__ */ React15.createElement("a", {
            href: redirectGSSUrl(redirectPath),
            "aria-label": ncTitle
        }, /* @__PURE__ */ React15.createElement(Viewport3, null, /* @__PURE__ */ React15.createElement(ViewMedium3, null, /* @__PURE__ */ React15.createElement(NotificationCenterGlobalNavButton, {
            name: ncIcon,
            buttonSize: UitkButtonSize6.LARGE,
            iconSize: UitkIconSize8.LARGE,
            onClick: entryPointClick
        })), /* @__PURE__ */ React15.createElement(ViewSmall3, null, /* @__PURE__ */ React15.createElement(UitkSpacing5, {
            padding: {
                block: "three",
                inline: "six"
            }
        }, /* @__PURE__ */ React15.createElement(UitkLink2, {
            className: "uitk-list-item"
        }, /* @__PURE__ */ React15.createElement("button", {
            type: "button",
            onClick: entryPointClick
        }, /* @__PURE__ */ React15.createElement(UitkText4, {
            size: 300,
            theme: "default"
        }, ncTitle))))))));
    }
    return /* @__PURE__ */ React15.createElement(NcListProvider, {
        notificationCenterObject: {
            notificationsList: notifications,
            unseenCount: unseen || 0
        },
        lineOfBusiness: lineOfBusiness,
        viewSize: viewSize
    }, /* @__PURE__ */ React15.createElement(Viewport3, null, /* @__PURE__ */ React15.createElement(ViewMedium3, null, /* @__PURE__ */ React15.createElement(NotificationCenterMenu, {
        ncTitle: ncTitle,
        ncRevealActions: ncRevealActions,
        ncIcon: ncIcon,
        emptyState: emptyState,
        deleteActionForm: deleteActionForm,
        onClick: ncScreenLoad
    })), /* @__PURE__ */ React15.createElement(ViewSmall3, null, /* @__PURE__ */ React15.createElement(NotificationCenterDialog, {
        ncTitle: ncTitle,
        ncRevealActions: ncRevealActions,
        ncIcon: ncIcon,
        emptyState: emptyState,
        deleteActionForm: deleteActionForm,
        onClick: ncScreenLoad
    }))));
};
NotificationCenter.displayName = "NotificationCenter";
export { NotificationCenter };
//# sourceMappingURL=index.js.map